"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserHubAssociation = void 0;
const useLogger_1 = require("./useLogger");
const mutations_1 = require("../graphql/mutations");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
// Amplify v6 rejects with a plain `{ data, errors }` object on a resolver
// failure, not an Error — without this, toasts read "[object Object]".
const toError = (error) => {
    if (error instanceof Error)
        return error;
    const message = error?.errors?.[0]?.message ?? error?.message;
    return new Error(message ?? String(error));
};
function useUserHubAssociation() {
    const logger = (0, useLogger_1.useLogger)('useUserHubAssociation');
    const associateHubWithUser = async (hubId, hubName) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.associateHub,
                variables: { hubId, hubName },
            });
            return response.data?.associateHub;
        }
        catch (error) {
            logger.error(`error associating a hub to the user, error: ${error}`);
            throw error;
        }
    };
    // Staff-side assignment: records "this hub belongs to customer X" before the
    // homeowner ever signs in. Amplify v6 resolves with `errors[]` + null data on
    // a resolver failure, so the guard is what stops a false success toast.
    const associateHubWithCustomer = async (hubId, userId, customerId) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.associateHubCustomer,
                variables: { hubId, userId, customerId },
                authMode: 'userPool',
            });
            if (response?.errors?.length) {
                throw new Error(response.errors[0].message);
            }
            return response.data?.associateHubCustomer;
        }
        catch (error) {
            const err = toError(error);
            logger.error(`error associating a hub to a customer, error: ${err.message}`);
            throw err;
        }
    };
    const dissociateHubFromCustomer = async (hubId, customerId) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.dissociateHubCustomer,
                variables: { hubId, customerId },
                authMode: 'userPool',
            });
            if (response?.errors?.length) {
                throw new Error(response.errors[0].message);
            }
            return response.data?.dissociateHubCustomer;
        }
        catch (error) {
            const err = toError(error);
            logger.error(`error dissociating a hub from a customer, error: ${err.message}`);
            throw err;
        }
    };
    return {
        associateHubWithUser,
        associateHubWithCustomer,
        dissociateHubFromCustomer,
    };
}
exports.useUserHubAssociation = useUserHubAssociation;
exports.default = useUserHubAssociation;
